import React, { FC, useState, useEffect, useCallback, useMemo } from 'react'

import { Grid } from 'semantic-ui-react'

import { Contacts } from '@/components/Contacts';

import { BackgroundImage, SliderContainer, TextDiv } from './style';
import { NormalHeader } from '../../pages/main_page/components/style';

export const Slider = (props) => (
    <SliderContainer>
        <BackgroundImage fluid src={props.background} />
        <Grid stackable>
            <Grid.Row>
                <Grid.Column width={8}>
                    <TextDiv>
                        <Contacts color={'rgba(0,0,0,.35)'} currentAct={props.currentAct} />
                    </TextDiv>
                    <TextDiv>
                        <NormalHeader>{props.header}</NormalHeader>
                    </TextDiv>
                </Grid.Column>
            </Grid.Row>
        </Grid>
    </SliderContainer>
)